import i18n from 'i18n';

function yearMonthPlugin() {
  return function(fp) {
    return {
      onReady() {
        if (fp.monthNav == null || fp.yearElements == null) {
          return;
        }

        const yearElement = fp.yearElements[0];

        const yearSuffix = document.createElement('i');
        yearSuffix.className = 'year-suffix';
        yearSuffix.innerHTML = i18n.t('common:yearSuffix');
        yearElement.parentElement.appendChild(yearSuffix);

        fp.monthNav
          .querySelector('.flatpickr-current-month')
          .insertBefore(
            yearElement.parentElement,
            fp.monthNav.querySelector('.cur-month')
          );
      },
      onOpen() {
        if (fp.yearElements == null) {
          return;
        }

        const yearElement = fp.yearElements[0];
        const interval = setInterval(() => {
          if (!yearElement.disabled) {
            yearElement.disabled = true;
            clearInterval(interval);
          }
        }, 10);
      }
    };
  };
}

export default yearMonthPlugin;



// WEBPACK FOOTER //
// ./src/components/common/DatepickerField/plugins/YearMonthPlugin.js